<script setup lang="ts">
import { RouterLink, RouterView, useRoute } from 'vue-router'
import { Menu as IconMenu, Lock } from '@element-plus/icons-vue'
import { ref, watch } from 'vue'
import Header from './components/header/Header.vue'
import { useDark } from '@vueuse/core'
import { useAuthStore } from '@/stores/auth/Auth'
import { ElMessageBox } from 'element-plus'
import { storeToRefs } from 'pinia'

import SideBar from '@/components/navigation/SideBar.vue'
import { useLayoutPreferencesStore } from '@/stores/layout/layoutPreferences'
import { useI18n } from 'vue-i18n'
import { useIsActiveRoute } from '@/composables/useIsActiveRoute'
import { ERouteName } from '@/router/ERouteName'

const layoutPreferences = useLayoutPreferencesStore()
const authStore = useAuthStore()
const { lockedDown, sessionActive } = storeToRefs(authStore)
const { isDarkMode } = storeToRefs(layoutPreferences)
const isDark = useDark()
const { t } = useI18n()

const narrowRouterView = new Set([
    ERouteName.CAMPAIGN_DATA,
    ERouteName.CAMPAIGN_DRAW,
    ERouteName.CAMPAIGN_PRIZE,
    ERouteName.CAMPAIGN_PROMO_PRODUCTS,
    ERouteName.CAMPAIGN_EMAILS,
    ERouteName.CAMPAIGN_FAQ,
    ERouteName.CAMPAIGN_TEAM,
    ERouteName.HIVE_EDIT,
    ERouteName.HIVE_CAMPAIGN_EDIT,
    ERouteName.SETTINGS_ACCOUNT,
    ERouteName.SETTINGS_ORGANIZATION
])

const { isActive } = useIsActiveRoute(narrowRouterView)

const narrowRouterViewStyle = {
    width: '100%',
    maxWidth: '800px',
    marginLeft: 'auto',
    marginRight: 'auto'
}

//Set the default state
isDark.value = isDarkMode.value
//Update State changes
watch(isDarkMode, (val) => {
    isDark.value = val
})

watch(lockedDown, () => {
    if (lockedDown) {
        ElMessageBox.close()
        ElMessageBox.confirm(
            t('settings.sessionExpiredSoon'),
            t('settings.sessionExpiredSoonMessage'),
            {
                confirmButtonText: t('settings.stayLoggedIn'),
                cancelButtonText: t('settings.logout'),
                type: 'info',
                showClose: false,
                icon: Lock
            }
        )
            .then(() => {
                authStore.refreshToken(10)
            })
            .catch(() => {
                authStore.logout()
            })
    }
})

watch(sessionActive, () => {
    if (!sessionActive) {
        ElMessageBox.close()
        ElMessageBox.confirm(t('settings.sessionExpired'), t('settings.sessionExpiredMessage'), {
            confirmButtonText: t('settings.relogin'),
            cancelButtonText: t('settings.logout'),
            type: 'info',
            showClose: false,
            icon: Lock
        })
            .then(() => {
                console.log('Refresh session!')
                location.reload()
            })
            .catch(() => {
                console.log('Error')
                authStore.logout()
            })
    }
})
</script>

<template>
    <div class="common-layout">
        <el-container>
            <SideBar></SideBar>
            <el-container>
                <Header></Header>

                <el-main :style="isActive ? narrowRouterViewStyle : {}">
                    <RouterView />
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<style scoped lang="scss"></style>
